import React from 'react';

import Modal from '../../../../components/Modal/Modal';

import './Modal.scoped.scss';

const Notification: React.FC<{ children?: React.ReactNode; openModal; handleModal }> = ({
  openModal,
  handleModal,
  children,
}) => {
  return (
    <Modal open={openModal} onClose={handleModal}>
      <div className="children">{children}</div>
    </Modal>
  );
};

export default Notification;
